import React, { forwardRef, type HTMLProps } from 'react';

import classnames from 'classnames';

import styles from './WaveEffect.module.scss';

const WaveEffect = forwardRef<HTMLDivElement, HTMLProps<HTMLDivElement>>(
    ({ className, ...props }: HTMLProps<HTMLDivElement>, ref) => {
        return (
            <div {...props} ref={ref} className={classnames(styles.base, styles.wave, className)} />
        );
    }
);

WaveEffect.displayName = 'WaveEffect';

export { WaveEffect };
